import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { MapDispatchToProps, MapStateToProps } from '~commonInfra/utils/ConnectUtils';
import { SessionSiteSelectors, SessionUserSelectors } from '~src/bootstrap/redux/selectors/SessionInfoSelectors';
import { selectSites } from '~src/siteManagement/selectors/SitesSelectors';
import { NavLocationSelectors } from '~src/spacesPlatform/selectors/NavigationStateSelectors';

import { AppState } from '../../../bootstrap/redux/state/AppState';
import { siteNamesRequest } from '../../actions/SitesNamesRequestAction';
import { SitePicker, SitePickerDispatchProps, SitePickerOwnProps, SitePickerStateProps } from './SitePicker';


const mapStateToProps: MapStateToProps<SitePickerStateProps> = (state: AppState) => ({
  currentSiteName: SessionSiteSelectors.siteName(state),
  sites: selectSites(state),
  inServerArea: NavLocationSelectors.inServerArea(state),
  isSessionServerAdmin: SessionUserSelectors.isSessionServerAdmin(state)
});

const mapDispatchToProps: MapDispatchToProps<SitePickerDispatchProps> =
  (dispatch) => bindActionCreators({
    requestSites: siteNamesRequest
  },
  dispatch);

export const ConnectedSitePicker: React.ComponentClass<SitePickerOwnProps> =
  connect(mapStateToProps, mapDispatchToProps)(SitePicker);
